/** Roles del panel web (alineado con backend). */
export function isStaffRole(role) {
  return role === 'admin' || role === 'super_admin';
}

export function isSuperAdmin(role) {
  return role === 'super_admin';
}
